<template>
  <section class="section">
    <h3>Deficiências</h3>

    <BaseProgressBar v-if="loading" v-bind="progressBar">
      Carregando tipos de deficiência...
    </BaseProgressBar>
    <p v-else-if="!deficienciaCollection.items.length" class="flow-text center">
      Nenhuma deficiência foi cadastrada.
    </p>
    <BaseCollection v-else>
      <template v-slot:items>
        <li
          v-for="(item, index) in deficienciaCollection.items"
          v-bind:key="index"
          class="collection-item"
        >
          <BaseDeficiencia v-bind="item" />
        </li>
      </template>
    </BaseCollection>
  </section>
</template>

<script>
import { API_URL, DEFAULT_COLOR, DEFAULT_LUMINOSITY } from "../../constants";
import BaseDeficiencia from "./BaseDeficiencia.vue";

export default {
  name: "DadosPessoaisDeficiencias",
  components: {
    BaseDeficiencia
  },
  inheritAttrs: false,
  props: {
    readonly: Boolean,

    pessoaFisica: {
      type: Object,
      required: true,
      validator: value => value.id !== null && value.id !== undefined
    },
    deficiencias: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      disabled: false,
      tiposDeficiencia: [],
      progressBar: {
        useContainer: false
      },
      deficienciaCollection: {
        items: []
      }
    };
  },
  created() {
    this.getTiposDeficiencia();
  },
  methods: {
    buildElementId(itemId, name) {
      return itemId
        ? `dadospessoais-deficiencia-${itemId}-${name}`
        : this.$utils.Object.uuid();
    },
    buildElementProps(itemId) {
      return {
        deficiencia: {
          id: this.buildElementId(itemId, "tipo"),
          label: "Tipo de deficiência",
          optionElements: this.tiposDeficiencia
        },
        principal: {
          color: DEFAULT_COLOR,
          luminosity: DEFAULT_LUMINOSITY,
          caption: "Principal"
        }
      };
    },
    getTiposDeficiencia() {
      this.loading = true;

      this.$http
        .get(`${API_URL}/core/tipoDeficiencia`)
        .then(response => (this.tiposDeficiencia = response.data))
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter os tipos de deficiência: ${error.message}`
          )
        )
        .finally(() => {
          this.deficienciaCollection.items = this.deficiencias.map(item => {
            const value = { ...item };

            if (this.tiposDeficiencia) {
              const tipo = this.tiposDeficiencia.find(
                td => td.codigo === item.tipoDeficienciaCodigo
              );

              value.tipo = tipo ? tipo.nome : null;
            }

            return {
              ...this.buildElementProps(item.id),
              value
            };
          });

          this.loading = false;
        });
    }
  }
};
</script>
